import { Injectable } from "@angular/core";
import { ShoppingCartService } from "@proxy/shopping-carts";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class CartStateService {
  private _itemCount = new BehaviorSubject<number>(0);
  readonly itemCount$ = this._itemCount.asObservable();

  constructor(private shoppingCartService: ShoppingCartService) {}

  setCount(count: number) {
    this._itemCount.next(count);
  }

  increment(by: number = 1) {
    this._itemCount.next(this._itemCount.value + by);
  }

  clear() {
    this._itemCount.next(0);
  }

  loadInitialCount(userId?: string) {
    if (!userId) return;

    this.shoppingCartService.getCart(userId).subscribe({
      next: cart => {
        this._itemCount.next(cart.totalItems ?? 0);
      },
      error: err => {
        console.warn('No se pudo cargar el carrito inicial', err);
        this._itemCount.next(0);
      },
    });
  }
}
